import { useForm } from 'react-final-form';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import styles from './ShareholderGrid.module.scss'
import { getIn } from 'final-form';
import { useEffect, useState } from 'react';
import { debtScheduleHeadersObj } from '../../Revenue Details/DebtSchedule/debtScheduleHelper';
import { NonEditableCell, ReactGrid } from '@silevis/reactgrid';
import { shortcutType } from '../../components/ReactGrid/reactGridHelper';
import { CustomTextCell } from '../../components/ReactGrid/CustomTextCell';
import { CustomNumberCell } from '../../components/ReactGrid/CustomNumberCell';
import { DateCell } from '../../components/ReactGrid/CustomDateCell';
import { getInitialShareholderDetails, getShareholdersGridInvalidRange, onAddInitialShareholderRow, shareholderColumns, shareholderColumnTitle, shareholderHeaders, shareholderHeadersObj } from './shareholderHelper';
import _ from 'lodash';
import { revenueGridStyles } from '../../Revenue Details/revenueGridStyles';
import { RiAddFill as AddIcon } from 'react-icons/ri'
import { Modal } from 'reactstrap';
import { BsFillExclamationCircleFill as WarningIcon } from 'react-icons/bs'
import { FieldMode, underwritingFormWarningType } from '../../../../interfaces/interfaces';
import ShortcutModal from '../../components/ReactGrid/ShortcutModal';
import { MdOutlineEdit as EditIcon } from 'react-icons/md'
import { getLastDayOfPreviousMonthFormatted } from '../../Revenue Details/DebtorSchedule/DebtorScheduleGrid';


type Props = {
  fieldName: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  fieldMode?: FieldMode;
  setFieldMode?: (value: FieldMode) => void;
  onChangeDetected?: () => void;
}

const getRows = (gridData) => {
  if (!gridData?.rowData?.length) return [];

  const headerRow = {
    rowIndex: 0,
    height: 42, // Explicitly setting height for headers
  };

  const dataRows = gridData.rowData.map((_, rowIndex) => ({
    rowIndex: rowIndex + 1, // Adjusting index for data rows
    height: 42,
  }));

  const footerRow = {
    rowIndex: gridData.rowData.length + 1, // Footer comes after last data row
    height: 42,
  };

  return [headerRow, ...dataRows, footerRow]; // Include header, data, and footer rows
};

const generateCells = (gridData, updateCellValue, addRow, deleteRow, fieldMode) => {
  // console.log('gridData', gridData);
  if (!gridData?.rowData?.length) return [];

  const headerCells = shareholderHeaders.map((header, colIndex) => {
    const headersObj = shareholderHeadersObj[header];
    return {
      rowIndex: 0,
      colIndex,
      isSelectable: false,
      isFocusable: false,
      Template: NonEditableCell,
      props: {
        value: headersObj?.title,
        style: {
          backgroundColor: "#F9F9F9",
          paddingTop: "0.75rem",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
          paddingBottom: "0.75rem",
          ...headersObj.styles,
        }
      },
    }
  });
  const dataCells = gridData.rowData.flatMap((row, rowIndex) => {
    console.log('row', row)
    return shareholderHeaders.map((headerKey, colIndex) => {
      const headersObj: any = shareholderHeadersObj[headerKey];
      const cellValue = row[headerKey];
      const allowShortcuts = gridData.rowData.length > 1 ? [shortcutType.addRow, shortcutType.deleteRow] : [shortcutType.addRow];
      const fieldType = headersObj?.fieldType

      console.log('fieldType', headersObj)

      if (fieldMode == FieldMode.view || fieldType == FieldMode.view) {
        return {
          rowIndex: rowIndex + 1,
          colIndex,
          isSelectable: true,
          isFocusable: true,
          Template: NonEditableCell,
          props: {
            value: cellValue,
            style: {
              backgroundColor: "#F9F9F9",
              paddingTop: "0.75rem",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              paddingBottom: "0.75rem",
              ...headersObj.styles,
            }
          },
        }
      } else if (headersObj?.type == "string") {
        return {
          rowIndex: rowIndex + 1,
          colIndex,
          Template: CustomTextCell,
          props: {
            text: cellValue,
            onTextChanged: (newText) => updateCellValue(rowIndex, headerKey, newText),
            onAddRow: (newRowIndex) => addRow(newRowIndex),
            onDeleteRow: (newRowIndex) => deleteRow(newRowIndex),
            allowShortcuts: allowShortcuts,
            style: {
              paddingTop: "0.75rem",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              paddingBottom: "0.75rem",
              ...headersObj.styles,
            }
          },
        }
      } else if (headersObj?.type == "number") {
        return {
          rowIndex: rowIndex + 1,
          colIndex,
          Template: CustomNumberCell,
          props: {
            value: cellValue,
            onValueChanged: (newValue) => updateCellValue(rowIndex, headerKey, newValue),
            onAddRow: (newRowIndex) => addRow(newRowIndex),
            onDeleteRow: (newRowIndex) => deleteRow(newRowIndex),
            allowShortcuts: allowShortcuts,
            style: {
              paddingTop: "0.75rem",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              paddingBottom: "0.75rem",
              ...headersObj.styles,
            }
          },
        }
      } else if (headersObj?.type == "date") {
        return {
          rowIndex: rowIndex + 1,
          colIndex,
          Template: DateCell,
          props: {
            value: cellValue,
            onValueChanged: (newValue) => updateCellValue(rowIndex, headerKey, newValue),
            onAddRow: (newRowIndex) => addRow(newRowIndex),
            onDeleteRow: (newRowIndex) => deleteRow(newRowIndex),
            allowShortcuts: allowShortcuts,
            style: {
              paddingTop: "0.75rem",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              paddingBottom: "0.75rem",
              ...headersObj.styles,
            }
          },
        }
      }
    })
  });

  const footerCells = shareholderHeaders.map((headerKey, colIndex) => {
    const headersObj = shareholderHeadersObj[headerKey];
    const cellValue = gridData.footer[headerKey];
    return {
      rowIndex: gridData.rowData.length + 1,
      colIndex,
      isSelectable: true,
      isFocusable: true,
      Template: NonEditableCell,
      props: {
        value: cellValue,
        style: {
          backgroundColor: "#F9F9F9",
          paddingTop: "0.75rem",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
          paddingBottom: "0.75rem",
          fontWeight: "600",
          ...headersObj.styles,
        }
      },
    }
  });

  // console.log('footerCells', footerCells);

  return [...headerCells, ...dataCells, ...footerCells];
}


const ShareholderGrid = ({ fieldName, isOpen, setIsOpen, fieldMode = FieldMode.edit, setFieldMode = () => { }, onChangeDetected = () => { } }: Props) => {
  const { getState, change } = useForm();

  const shareholderDetails = getIn(getState()?.values, `${fieldName}`);

  const [styledRanges, setStyledRanges] = useState([]);


  const [gridData, setGridData] = useState({
    headers: [],
    rowData: [],
    footer: {}
  });

  const [validation, setValidation] = useState({
    message: '',
    styledRange: []
  });

  const [initialGridData, setInitialGridData] = useState(null);
  const [isShorcutModalOpen, setIsShorcutModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [warning, setWarning] = useState({
    state: false,
    type: null
  });

  useEffect(() => {
    if (isOpen) {
      if (!shareholderDetails) {
        const shareholderGridData = getInitialShareholderDetails();
        console.log('shareholderGridData', shareholderGridData);
        setGridData(shareholderGridData);
        setInitialGridData(_.cloneDeep({
          headers: shareholderGridData.headers,
          rowData: shareholderGridData.rowData,
          footer: shareholderGridData.footer
        }))
      } else {
        // console.log('shareholderDetails', shareholderDetails);
        setInitialGridData(_.cloneDeep(shareholderDetails));
        setGridData(shareholderDetails);
      }
    }
  }, [isOpen]);

  const recalculateHoldingPerc = (rowData) => {
    console.log('recalculatePercColumn called with rowData:', rowData);
    const manipulatedRowData = _.cloneDeep(rowData);

    // Calculate total shares
    const totalShares = manipulatedRowData.reduce((sum, row) => {
      const shares = parseFloat(row.noOfShares);
      return sum + (isNaN(shares) ? 0 : shares);
    }, 0);

    // Update each row with calculated holdings %
    manipulatedRowData.forEach(row => {
      const shares = parseFloat(row.noOfShares);
      if (!isNaN(shares) && totalShares > 0) {
        row.holdings = ((shares / totalShares) * 100).toFixed(2); // string with 2 decimals
      } else {
        row.holdings = '';
      }
    });

    console.log('Updated manipulatedRowData:', manipulatedRowData);
    return {
      manipulatedRowData,
      manipulatedFooterData: {
        [shareholderColumns.holdings]: 100
      }
    };
  };

  const updateCellValue = (rowIndex: string, columnKey: string, value) => {
    setGridData((prev) => {
      // console.log('path', path, 'value', value);
      const newGridData = _.cloneDeep(prev?.rowData);
      _.set(newGridData, `${rowIndex}.${columnKey}`, value);

      const { manipulatedRowData, manipulatedFooterData } = recalculateHoldingPerc(newGridData);

      const footerData = _.cloneDeep(prev?.footer);
      // const [rowIndex, colIndex] = path.match(/\d+/g).map(Number);
      // calculate row sum 
      const headersObj = shareholderHeadersObj[columnKey];
      if (headersObj?.isTotal) {
        const sum = manipulatedRowData.reduce((acc, row) => {
          return acc + (row[columnKey] || 0);
        }, 0);
        // newGridData[newGridData.length - 1][colIndex] = sum;
        if (manipulatedRowData.length == 1 && !sum) footerData[columnKey] = "-";
        else footerData[columnKey] = sum;
      }
      console.log('footerData', footerData)
      return {
        ...prev,
        rowData: manipulatedRowData,
        footer: {
          ...footerData,
          ...manipulatedFooterData
        },
      };
    })
  }

  const addRow = (rowIndex: number) => {
    setGridData((prev) => {
      const newGridData = _.cloneDeep(prev?.rowData);
      newGridData.splice(rowIndex, 0, onAddInitialShareholderRow());
      return {
        ...prev,
        rowData: newGridData,
      };
    })
  }

  const deleteRow = (rowIndex: number) => {
    // console.log('rowIndex', rowIndex);
    setGridData((prev) => {
      const newGridData = _.cloneDeep(prev?.rowData);
      newGridData.splice(rowIndex, 1);
      // calculate footer sum
      const footerData = {};
      shareholderHeaders.forEach((headerKey, colIndex) => {
        footerData[headerKey] = 0;
      });


      newGridData.forEach((row, rowIndex) => {
        shareholderHeaders.forEach((headerKey, colIndex) => {
          const cellValue = row[headerKey];
          const headersObj = shareholderHeadersObj[headerKey];
          if (headersObj?.isTotal) {
            const sumValue = (footerData[headerKey] || 0) + (cellValue || 0);
            if (newGridData?.length == 1 && !sumValue) footerData[headerKey] = "-";
            else footerData[headerKey] = sumValue;
          } else {
            if (colIndex == 0) footerData[headerKey] = "Total";
            else footerData[headerKey] = "-";
          }
        })
      });

      const { manipulatedRowData, manipulatedFooterData } = recalculateHoldingPerc(newGridData);


      return {
        ...prev,
        rowData: manipulatedRowData,
        footer: {
          ...footerData,
          ...manipulatedFooterData
        },
      }
    });
  }

  const columns = shareholderHeaders.map((_, colIndex) => ({
    colIndex,
    width: 180,
  }));

  const rows = getRows(gridData);
  const cells = generateCells(gridData, updateCellValue, addRow, deleteRow, fieldMode);

  const validateGrid = () => {
    const { partialDataErrors, totalHoldingError } = getShareholdersGridInvalidRange(gridData);


    // if(gridData.rowData.length == 1 && partialDataErrors.length)
    if (totalHoldingError.length) {

      setValidation(prev => ({
        message: "Shareholding must equal 100%",
        styledRange: totalHoldingError
      }));
      return false;
    } else if (partialDataErrors.length) {
      // console.log('partialDataErrors', partialDataErrors);
      setValidation(prev => ({
        message: "Some cells are missing data",
        styledRange: partialDataErrors
      }));
    }

    return partialDataErrors.length == 0 && totalHoldingError.length == 0;
  }

  const handelChangeDetected = () => {
    const stringifiedPrevData = JSON.stringify(initialGridData);
    const stringifiedNewData = JSON.stringify(gridData);
    if (stringifiedPrevData !== stringifiedNewData) {
      onChangeDetected();
    }
  }

  return (
    <div className={styles.rootContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.leftContainer}>
          <div className={styles.title}>
            Shareholding Pattern (As of {getLastDayOfPreviousMonthFormatted()})
          </div>
        </div>


        <div className={styles.rightContainer}>
          <MeritoButton
            btnText={fieldMode == FieldMode.view ? "Edit" : "Save"}
            type='primary-1'
            icon={fieldMode == FieldMode.view ? <EditIcon /> : null}
            onClick={() => {
              // save the provisional statement
              if (fieldMode == FieldMode.view) {
                setFieldMode(FieldMode.edit);
                return;
              }
              const isValid = validateGrid();
              setIsSubmitted(true);
              if (isValid) {
                change(fieldName, gridData);
                handelChangeDetected();
                setIsOpen(false);
              } else {
                setWarning({
                  state: true,
                  type: underwritingFormWarningType.save
                })
              }
            }}
          />
          <MeritoButton
            btnText="Cancel"
            type='secondary-1'
            onClick={() => {
              const stringifiedPrevData = JSON.stringify(initialGridData);
              const stringifiedNewData = JSON.stringify(gridData);

              console.log('initialGridData', initialGridData);
              console.log('gridData', gridData);
              if (stringifiedPrevData !== stringifiedNewData) {
                setWarning({
                  state: true,
                  type: underwritingFormWarningType.cancel
                });
              } else {
                setIsOpen(false)
              }
            }}
          />
        </div>
      </div>
      <div className={styles.tipsContainer}>
        <div className={styles.tipsTitle}>
          Tips:
        </div>
        <div className={styles.tipsContent}>
          <ol>
            <li>You can use these <span onClick={() => {
              setIsShorcutModalOpen(true)
            }}>spreadsheet shortcuts.</span></li>
          </ol>
        </div>
      </div>
      <div className={styles.tableRootContainer}>
        {gridData?.rowData?.length ? <ReactGrid
          id="shareholderGrid"
          columns={columns}
          rows={rows}
          cells={cells}
          stickyTopRows={1}
          stickyBottomRows={1}
          styledRanges={validation.styledRange}
          styles={revenueGridStyles?.rgStyles}
        /> : null}
      </div>
      {validation.message ? <div className={styles.errorMessage}>
        {validation.message}
      </div> : null}
      <div className={styles.btnContainer}>
        <MeritoButton
          type="secondary-1"
          size="md"
          disabled={fieldMode == FieldMode.view}
          icon={<AddIcon />}
          btnText="Insert Row"
          onClick={() => {
            if (fieldMode == FieldMode.view) return;
            addRow(gridData.rowData.length);
          }}
        />
      </div>

      <Modal
        size={"md"}
        isOpen={warning?.state}
        toggle={() => {
          setWarning({ state: false, type: null });
        }}
        centered={true}
        style={{ width: '450px' }}
        contentClassName='shortcut_modal'
      >
        <div className={styles.confirmationRootContainer}>
          <div className={styles.topContainer}>
            <div className={styles.iconContainer}>
              <WarningIcon />
            </div>
            <div className={styles.messageContainer}>
              {warning?.type === underwritingFormWarningType.save ? 'Required Details Are Missing!' : 'Unsaved Changes Will Be Lost!'}
            </div>
            {warning?.type == underwritingFormWarningType.save ? <div className={styles.subMessageContainer}>
              Do you want to proceed anyway?
            </div> : null}
          </div>

          <div className={styles.bottomContainer}>
            {warning?.type === underwritingFormWarningType.save ?
              <>
                <MeritoButton
                  btnText={'Save & Continue'}
                  size='lg'
                  isRounded={true}
                  type='secondary-2'
                  onClick={() => {
                    handelChangeDetected();
                    change(fieldName, gridData);
                    setWarning({
                      state: false,
                      type: null
                    })
                    setIsOpen(false);

                  }}
                />
                <MeritoButton
                  btnText="Continue Editing"
                  size='lg'
                  isRounded={true}
                  type='primary-1'
                  onClick={() => {
                    setWarning({
                      state: false,
                      type: null
                    });
                  }}
                />
              </>
              :
              <>
                <MeritoButton
                  btnText={'Delete Changes'}
                  size='lg'
                  isRounded={true}
                  type='secondary-2'
                  onClick={() => {
                    setWarning({
                      state: false,
                      type: null
                    })
                    setIsOpen(false);
                  }}
                />
                <MeritoButton
                  btnText="Continue Editing"
                  size='lg'
                  isRounded={true}
                  type='primary-1'
                  onClick={() => {
                    setWarning({
                      state: false,
                      type: null
                    });
                  }}
                />
              </>
            }

          </div>
        </div>
      </Modal>

      <ShortcutModal isOpen={isShorcutModalOpen} setIsOpen={setIsShorcutModalOpen}
        showShortcuts={[shortcutType.addRow, shortcutType.deleteRow, shortcutType.cut, shortcutType.copy, shortcutType.paste, shortcutType.moveLeft, shortcutType.moveRight]} />
    </div>
  );
}

export default ShareholderGrid;